import {Component, OnChanges, Input} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {TypesService} from '../../../services';
import * as _ from 'lodash';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-solicitor-panel-details',
    templateUrl: './solicitor-panel-details.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule,
      NgFor, NgIf, MatOptionModule, ValidationPartialComponent, MatCheckboxModule]
})

export class SolicitorPanelDetailsComponent extends WizardWidgetComponent implements OnChanges {
  @Input() public originatorDetails: any;
  @Input() public securityDetails: any;
  @Input() public isMcca = false;

  public panelSolicitorTypes = [];
  public allPanelSolicitorTypes = [];
  public mortgageDocTypes = [];
  public allMortgageDocTypes = [];

  private panelSolicitorTypesSlug = 'panel-solicitors-vx';
  private mortgageDocTypesSlug = 'document-instructions-method';

  constructor(public dataHandlerService: DataHandlerService,
              private typesService: TypesService) {
    super(dataHandlerService);
    this.initialize();
  }

  initialize() {
    console.log(this.originatorDetails);
    this.panelSolicitorTypes = [];
    this.typesService.getTypesList(this.panelSolicitorTypesSlug)
      .then((results) => {
        this.panelSolicitorTypes = results;
        this.allPanelSolicitorTypes = results;
        this.filterSolicitors(this.originatorDetails, this.securityDetails);
      });

    this.mortgageDocTypes = [];
    this.typesService.getTypesList(this.mortgageDocTypesSlug)
      .then((results) => {
        this.allMortgageDocTypes = results;
        this.filterDocInstructionsBasedOnOriginator();
      });
  }

  public filterDocInstructionsBasedOnOriginator() {
    if (this.originatorDetails && this.originatorDetails.id) {
      this.mortgageDocTypes = _.filter(this.allMortgageDocTypes,
        t => {
          return !(t.ext && t.ext.excludeFromOriginators
            && t.ext.excludeFromOriginators.includes(this.originatorDetails.id));
        });
    } else {
      this.mortgageDocTypes = this.allMortgageDocTypes;
    }
  }

  ngOnChanges(changes) {
    if (changes && changes.originatorDetails || changes.securityDetails) {
      this.filterSolicitors(this.originatorDetails, this.securityDetails);
      this.filterDocInstructionsBasedOnOriginator();
    }
  }

  public filterSolicitors(originatorDetails, securityDetails) {
    let states = [];
    if (this.allPanelSolicitorTypes.length > 0 && originatorDetails && securityDetails) {
      // get the default solicitor
      let defaultSolicitor = this.allPanelSolicitorTypes.find(ap => ap.ext && ap.ext.states === null && ap.ext.originators === null && ap.ext.default === true);
      states = securityDetails.map((security) => {
        return security.securityAddress && security.securityAddress.stateSlug;
      });
      const solicitorsForOriginator = this.allPanelSolicitorTypes.filter(
        ap => ap.ext &&
          ap.ext.originators &&
          ap.ext.originators.indexOf(Number(originatorDetails.id)) !== -1);

      const solicitorsForState = solicitorsForOriginator.filter(
        ap => ap.ext &&
          ap.ext.states &&
          ap.ext.states.find(x => states.includes(x)));

      if (solicitorsForState.length > 0) {
        this.panelSolicitorTypes = solicitorsForState;
        defaultSolicitor = this.panelSolicitorTypes.find(ap => ap.ext && ap.ext.default === true);
      } else {
        this.panelSolicitorTypes = [defaultSolicitor];
      }
      // patch the default if user has none selected
      if (defaultSolicitor && !this.formGroup.value.panelSolicitor) {
        this.formGroup.patchValue({panelSolicitor: defaultSolicitor.id});
      }
    }
  }
}
